<div class="missing-card">
  <header class="card-head">
    <div class="title-block">
      <h3>Missing Tunings</h3>
      <p>Files awaiting matching attention</p>
    </div>
    <span class="total-pill" *ngIf="grandTotal() > 0">{{ grandTotal() | number }} TOTAL</span>
  </header>

  <ng-container *ngIf="!isLoading()">
    <div class="summary-tiles" *ngIf="grandTotal() > 0">
      <!-- Partial tile -->
      <div class="tile partial-tile clickable" (click)="openPartialTable()">
        <div class="tile-head">
          <span class="tile-label">PARTIAL</span>
          <span class="tile-pct">{{ partialPct() }}%</span>
        </div>
        <div class="tile-value amber">{{ partialTotal() | number }}</div>
        <div class="tile-bar">
          <div class="tile-bar-fill amber-fill" [style.width.%]="partialPct()"></div>
        </div>
      </div>

      <!-- Missing tile -->
      <div class="tile missing-tile clickable" (click)="openMissingTable()">
        <div class="tile-head">
          <span class="tile-label">MISSING</span>
          <span class="tile-pct">{{ missingPct() }}%</span>
        </div>
        <div class="tile-value red">{{ missingTotal() | number }}</div>
        <div class="tile-bar">
          <div class="tile-bar-fill red-fill" [style.width.%]="missingPct()"></div>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="grandTotal() === 0">
      <i class="bi bi-check-circle"></i>
      <p>No missing tunings</p>
    </div>
  </ng-container>

  <div class="loading-state" *ngIf="isLoading()">
    <div class="tile-skeleton-row">
      <div class="tile-skeleton"></div>
      <div class="tile-skeleton"></div>
    </div>
    <div class="bar-skeleton" *ngFor="let _ of [1,2,3,4]"></div>
  </div>
</div>
